import React, { useState } from 'react';
import { signInWithEmailAndPassword, signInWithPopup } from 'firebase/auth';
import { auth, googleProvider } from './../../firebaseConfig';
import Input from '../ui/Input';
import Button from '../ui/Button';
import './Login.css';
import GoogleIcon from '../../assets/logos/google.svg';

interface LoginProps {
  onSwitch: () => void;
  onReset: () => void;
}

const Login: React.FC<LoginProps> = ({ onSwitch, onReset }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  // Email/Password Login
  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      await signInWithEmailAndPassword(auth, email, password);
      console.log('Login successful');
      // Redirect or trigger a state update after login
    } catch (err: any) {
      setError('Failed to login. ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  // Google Sign-in
  const handleGoogleLogin = async () => {
    setError(null);
    setLoading(true);

    try {
      await signInWithPopup(auth, googleProvider);
      console.log('Google login successful');
      // Redirect or trigger a state update after login
    } catch (err: any) {
      setError('Failed to login with Google. ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <h2 className="login-title">Login to your Account</h2>
      <p className="login-subtext">
        If you don’t have an account, please{' '}
        <span onClick={onSwitch} className="link">Sign Up</span>
      </p>
      <form onSubmit={handleLogin} className="login-form">
        <Input
          type="email"
          placeholder="Your Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        {error && <p className="error-message">{error}</p>}
        <p className="forgot-password">
          Forgot the password?{' '}
          <span onClick={onReset} className="link">Reset</span>
        </p>
        <Button type="submit" width="100%" disabled={loading}>
          {loading ? 'Logging in...' : 'Login'}
        </Button>
      </form>
      <div className="divider">
        <span>Or</span>
      </div>
      <Button
        type="button"
        variant="outline"
        width="100%"
        onClick={handleGoogleLogin}
        disabled={loading}
      >
        <img src={GoogleIcon} alt="Google Icon" className="google-icon" />
        {loading ? 'Loading...' : 'Login with Google'}
      </Button>
    </div>
  );
};

export default Login;
